import { mutatorAction } from 'satcheljs';
import { mailListItemAnimationStore } from '../store/Store';
import { cancelAllRowAnimationsForAnimation } from '../utils/cancelAllRowAnimationsForAnimation';

export const removeCompletedAnimations = (): void => {
    const { completedAnimations } = mailListItemAnimationStore();
    for (const animation of completedAnimations) {
        cancelAllRowAnimationsForAnimation(animation);
    }
    removeCompletedAnimationsMutator();
};

const removeCompletedAnimationsMutator: () => void = mutatorAction(
    'removeCompletedAnimations',
    (): void => {
        mailListItemAnimationStore().completedAnimations = [];
    }
);
